var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { HayDayItems } from '../../models/haydayitem';
export var HayDayItemDisplay = (function () {
    function HayDayItemDisplay() {
        this.size = 32;
        this.item = HayDayItems.None;
    }
    HayDayItemDisplay.prototype.ngOnChanges = function (changes) {
        if (this.id) {
            this.item = HayDayItems.getItemById(this.id);
        }
    };
    __decorate([
        Input("itemid"), 
        __metadata('design:type', Number)
    ], HayDayItemDisplay.prototype, "id", void 0);
    __decorate([
        Input("size"), 
        __metadata('design:type', Number)
    ], HayDayItemDisplay.prototype, "size", void 0);
    __decorate([
        Input("count"), 
        __metadata('design:type', String)
    ], HayDayItemDisplay.prototype, "count", void 0);
    HayDayItemDisplay = __decorate([
        Component({
            selector: 'hayday-item',
            template: '<span class="hd-item-icon-{{size}} {{item?.sprite}}"><ion-badge>{{count}}</ion-badge></span>'
        }), 
        __metadata('design:paramtypes', [])
    ], HayDayItemDisplay);
    return HayDayItemDisplay;
}());
